import type { AdminScoreFilter, AdminViewMode } from "@/lib/admin-api";

export const adminDashboardQueryKey = (
  page: number,
  search: string,
  score: AdminScoreFilter,
  viewMode: AdminViewMode = "visitor",
) => ["admin", "dashboard", { page, search, score, viewMode }] as const;

export const adminDashboardRootKey = ["admin", "dashboard"] as const;

export const adminVisitsQueryKey = (page: number, search: string) =>
  ["admin", "visits", { page, search }] as const;

export const adminVisitsRootKey = ["admin", "visits"] as const;
